import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { MarkdownOrText } from "../Common/MarkdownOrText";
export function PropertyAlert(props) {
    const { property, severity, showIcon, textMode } = props;
    const content = property.isLanguageDependent ? (_jsx(PropertyAlertLdpContent, { property: property, textMode: textMode })) : (_jsx(Fragment, { children: property.value }));
    return (_jsx(Alert, { severity: severity, icon: showIcon ? undefined : false, children: content }));
}
function PropertyAlertLdpContent(props) {
    const { property, textMode } = props;
    const { name, description } = property;
    // only render name as simple text if there is no description
    if (name && !description) {
        return _jsx(MarkdownOrText, { text: property.name, textMode: textMode });
    }
    const title = name && (_jsx(AlertTitle, { children: _jsx(MarkdownOrText, { text: property.name, textMode: textMode }) }));
    const content = description && (_jsx(MarkdownOrText, { text: property.description, textMode: textMode }));
    return (_jsxs(Fragment, { children: [title, content] }));
}
//# sourceMappingURL=PropertyAlert.js.map